import { Theme } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const actualWidth = window.innerWidth;

const themeKym = makeStyles((theme: Theme) => ({
  TitleSection: {
    fontFamily: "Roboto",
    fontSize: 18,
    fontWeight: 600,
    lineHeight: "32px",
    color: "#4C5866",
    [theme.breakpoints.down("xs")]: {
      fontFamily: "Roboto",
      fontStyle: "normal",
      fontWeight: "500",
      fontSize: "16px",
      lineHeight: "20px",
      color: "#5F6368",
    },
  },
  AvatarForm: {
    backgroundColor: "#FFC70D !important",
    color: "#FFFFFF !important",
    [theme.breakpoints.down("xs")]: {
      width: "24px !important",
      height: "24px !important",
      background: "#FFC70D !important",
    },
  },
  sectionContainer: {
    [theme.breakpoints.down("xs")]: {
      paddingTop: "25px !important",
    },
  },
  footerContainer: {
    fontFamily: "Roboto !important",
    fontStyle: "normal !important",
    fontWeight: "300 !important",
    fontSize: "16px !important",
    lineHeight: "24px !important",
    color: "#000000 !important",
    [theme.breakpoints.up("xs")]: {
      paddingTop: "30px",
    },
    [theme.breakpoints.down("xs")]: {
      fontStyle: "normal",
      fontWeight: "400",
      fontSize: "12px !important",
      lineHeight: "14px",
      textAlign: "justify",
      paddingRight: "15px",
    },
  },
  FormKym: {
    [theme.breakpoints.down("xs")]: {
      padding: "0px",
      backgroundColor: "#E5E5E5",
    },
  },
  mainGridContainer: {
    height: "55vh",
  },
  gridSectionButton: {
    height: "30%",
  },
  gridSectionForm: {
    height: "70%",
    [theme.breakpoints.down("xs")]: {
      maxHeight: "80%",
      padding: "20px",
      paddingTop: "0px",
      width: (props) => props.width,
    },
  },
  gridForm: {
    [theme.breakpoints.down("xs")]: {
      marginLeft: "0px !important",
      width: (props) => props.width,
    },
  },
  Title: {
    marginTop: "80px",
    fontFamily: "Roboto !important",
    fontWeight: "600 !important",
    lineHeight: "35px !important",
    color: "#404A56 !important",
    [theme.breakpoints.down("xs")]: {
      fontFamily: "Roboto !important",
      fontStyle: "normal !important",
      fontWeight: "700 !important",
      fontSize: "20px !important",
      lineHeight: "24px !important",
      color: "#00377D !important",
      width: "100%",
    },
  },
  Subtitle: {
    fontFamily: "Roboto !important",
    fontWeight: "400 !important",
    lineHeight: "30px !important",
    color: "#404A56 !important",
    [theme.breakpoints.down("xs")]: {
      fontFamily: "Roboto !important",
      fontStyle: "normal !important",
      fontWeight: "400 !important",
      fontSize: "16px !important",
      lineHeight: "24px !important",
      color: "#343C46 !important",
      width: "100%",
    },
  },
  titleWC: {
    [theme.breakpoints.up("xs")]: {
      textAlign: "center !important",
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "start !important",
    },
  },
  subtitleWC: {
    [theme.breakpoints.up("xs")]: {
      textAlign: "center !important",
    },
    [theme.breakpoints.down("xs")]: {
      textAlign: "start !important",
    },
  },
  boxTitleContainer: {
    marginTop: "80px",
    width: "90%",
    [theme.breakpoints.down("xs")]: {
      marginTop: "30px",
      paddingBottom: "16px",
      width: "100%",
    },
  },
  stackButtons: {
    [theme.breakpoints.down("xs")]: {
      marginTop: "0px !important",
      width: (props) => props.width,
    },
  },
  textFieldWC: {
    background: "#FFFFFF",
    width: "100%",
    "& .MuiOutlinedInput-input": {
      border: "none !important",
    },
    "& .MuiInputBase-input": {
      border: "none !important",
      [theme.breakpoints.down("xs")]: {
        fontFamily: "Roboto !important",
        fontStyle: "normal !important",
        fontWeight: "400 !important",
        fontSize: "14px !important",
        lineHeight: "16px !important",
        color: "#343C46 !important",
      },
    },
    "& .MuiFormLabel-root": {
      fontFamily: "Roboto !important",
      fontStyle: "normal !important",
      fontWeight: "400 !important",
      fontSize: "14px !important",
      lineHeight: "16px !important",
    },
    "& .MuiInputLabel-formControl": {
      fontFamily: "Roboto !important",
      fontStyle: "normal !important",
      fontWeight: "400 !important",
      fontSize: "12px !important",
      lineHeight: "12px !important",
    },
    border: "1px solid #BFC7D0 !important",
    borderRadius: "8px !important",
  },
  Container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  Card: {
    width: "90%",
    background: "#FFF",
    marginBottom: "10px",
    borderRadius: "16px",
    boxShadow: "0px 4px 12px rgba(194, 209, 217, 0.46)",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      borderRadius: "8px",
    },
  },
  RadioButtonLbl: {
    fontFamily: "Roboto !important",
    fontStyle: "normal !important",
    width: "100% !important",
    padding: "30px !important",
    display: "flex !important",
    justifyContent: "flex-start !important",
    flexWrap: "wrap !important",
    marginBottom: "0px !important",
    [theme.breakpoints.down("xs")]: {
      padding: "15px 15px 0px 15px !important",
    },
  },
  Input: {
    marginRight: "10px",
  },
  RadioSubtitle: {
    display: "none !important",
    [theme.breakpoints.down("xs")]: {
      display: "flex !important",
      justifyContent: "flex-start !important",
      flexWrap: "wrap !important",
      marginBottom: "0px !important",
      fontFamily: "Roboto !important",
      fontStyle: "normal !important",
      fontWeight: "400 !important",
      fontSize: "10px !important",
      lineHeight: "12px !important",
      color: "#708195 !important",
      padding: "0px 15px 15px 55px !important",
    },
  },
  mainGridContainerWC: {
    height: "95vh !important",
  },
  classButtons: {
    [theme.breakpoints.down("xs")]: {
      width: "50%",
    },
  },
}));

export default themeKym;
